<template>
  <div>
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <div class="flex_between_wrap">
        <el-form-item
          :prop="item.model"
          style="width:300px;"
          v-for="(item, sindex) in firstItem"
          :key="sindex"
          :label="item.label"
          :rules="
            item.label == '退还日期' ? formRules.requiredChange : formRules.not
          "
        >
          <el-date-picker
            style="width:100%"
            v-if="item.label == '退还日期'"
            v-model="formParams[item.model]"
            align="right"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="`选择` + '退还日期'"
     
            :picker-options="{
                
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [
                {
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  },
                },
                {
                  text: '昨天',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                  },
                },
                {
                  text: '一周前',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                  },
                },
              ],
            }"
          >
          </el-date-picker>
          <el-input
            type="textarea"
            v-else
            v-model="formParams[item.model]"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ids: Array,
    callBack: Function,
  },
  data() {
    return {
      formParams: {
        retTime:'',
        ids: this.ids,
      },
      firstItem: [
        {
          label: "退还日期",
          model: "retTime",
        },
        {
          label: "备注",
          model: "remark",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    init(){
      this.$set(this.formParams,'retTime',this.$getCurrentDate())
    },
    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        this.$requestAxiosForm(
          {
            url: "/pc/operate/receive/ret",
            data: this.formParams,
          },
          (data) => {
            this.$success();
            this.closeDialog();
            this.callBack();
          }
        );
      });
    },
  },
};
</script>
<style scoped></style>
